import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { RouterModule } from "@angular/router";

import { ButtonComponent } from "../button/button.component";
import { TypeTileFields } from "../../../models/contentful-content-types/tile";
import { AssetFile } from "contentful";

@Component({
  imports: [RouterModule, CommonModule, ButtonComponent],
  selector: "jnguyen-tile",
  templateUrl: "./tile.component.html",
  styleUrls: ["./tile.component.scss"],
})
export class TileComponent {
  @Input() data: TypeTileFields;

  getImageUrl(url: string | AssetFile) {
    if (typeof url === "string") {
      const cutUrl = url.replace(/\/\/images\.ctfassets\.net\//, "");
      return `${cutUrl}`;
    }
  }
}
